import { Component, inject } from '@angular/core';
import { VendorContactService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorContactCreateDto,
  VendorContactDto,
  VendorContactExcelDownloadDto,
  VendorContactUpdateDto,
} from '../proxy/controlling/dtos/vendor-contact';
import { VENDORCONTACT_CONFIG, VENDORCONTACT_FIELDS } from './vendor-contact.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-contact',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorContactService, ConfirmationService],
  templateUrl: './vendor-contact.html',
  styleUrl: './vendor-contact.scss',
})
export class VendorContact extends BaseHierarchicalCrudComponent<
  VendorContactDto,
  VendorContactCreateDto,
  VendorContactUpdateDto,
  VendorContactExcelDownloadDto
> {
  service = inject(VendorContactService);
  config = VENDORCONTACT_CONFIG;
  fields = VENDORCONTACT_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorContactDto): VendorContactUpdateDto {
    return {
      name: data.name,
      vendorId: selected.vendorId,
      telephoneNumber: data.telephoneNumber,
      cellphoneNumber: data.cellphoneNumber,
      faxNumber: data.faxNumber,
      email: data.email,
      canReceiveEmail: data.canReceiveEmail,
      vendorContactTypeId: data.vendorContactTypeId,
      mustNotifyServiceOrderApproval: data.mustNotifyServiceOrderApproval,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorContact';
  }
}
